(() => {
  const SELECTOR = '[data-minaco-welcome-popup]';
  const STORAGE_KEY = 'minaco_welcome_popup_dismissed_at';
  const SUBSCRIBED_KEY = 'minaco_welcome_popup_subscribed';

  function init(root) {
    if (!root || root.dataset.mwpReady === 'true') return;
    root.dataset.mwpReady = 'true';

    const dialog = root.querySelector('.minaco-welcome-popup__dialog');
    const closeButtons = root.querySelectorAll('[data-mwp-close]');
    const mediaVideo = root.querySelector('.minaco-welcome-popup__video');
    const enabled = root.dataset.enabled === 'true';
    const delay = Math.max(0, Number(root.dataset.delay || 0));
    const repeatDays = Math.max(1, Number(root.dataset.repeatDays || 14));
    const success = root.dataset.success === 'true' || !!root.querySelector('[data-mwp-success]');
    let opener = null;
    let timer = null;

    const storageAvailable = (() => {
      try {
        localStorage.setItem('__mwp_test', '1');
        localStorage.removeItem('__mwp_test');
        return true;
      } catch (_) { return false; }
    })();

    function open({ force = false } = {}) {
      if (!force && (!enabled || root.classList.contains('is-open'))) return;
      opener = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('minaco-welcome-popup-open');
      if (mediaVideo) {
        mediaVideo.muted = true;
        const playPromise = mediaVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
      }
      requestAnimationFrame(() => dialog?.focus({ preventScroll: true }));
    }

    function rememberDismissal() {
      if (!storageAvailable || window.Shopify?.designMode) return;
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    }

    function close({ remember = true } = {}) {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('minaco-welcome-popup-open');
      if (mediaVideo) mediaVideo.pause();
      if (remember) rememberDismissal();
      if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
    }

    function shouldOpen() {
      if (!enabled) return false;
      if (success) return true;
      if (!storageAvailable) return true;
      if (localStorage.getItem(SUBSCRIBED_KEY) === '1') return false;
      const dismissedAt = Number(localStorage.getItem(STORAGE_KEY) || 0);
      if (!dismissedAt) return true;
      return Date.now() - dismissedAt >= repeatDays * 86400000;
    }

    function scheduleOpen() {
      if (window.Shopify?.designMode || !shouldOpen()) return;
      const attempt = () => {
        const cookie = document.querySelector('[data-minaco-cookie-consent].is-open');
        if (cookie) {
          timer = window.setTimeout(attempt, 650);
          return;
        }
        open();
      };
      timer = window.setTimeout(attempt, success ? 50 : delay);
    }

    closeButtons.forEach((button) => button.addEventListener('click', () => close({ remember: !success })));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab' || !root.classList.contains('is-open')) return;
      const focusables = [...root.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    if (success) {
      if (storageAvailable) localStorage.setItem(SUBSCRIBED_KEY, '1');
      open({ force: true });
    } else {
      scheduleOpen();
    }

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === root.dataset.sectionId) {
        if (timer) clearTimeout(timer);
        open({ force: true });
      }
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.detail.sectionId === root.dataset.sectionId) close({ remember: false });
    });
  }

  function boot(scope = document) { scope.querySelectorAll(SELECTOR).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
